import React, { FC, PropsWithChildren } from "react";

import styled from "styled-components";
import { Hidden } from "@mui/material";

import { breakpoints } from "@/styles/breakpoints";

type SectionTitleProps = {
    title: string;
    mobileTitle?: string;
    [x: string]: any;
};

export const StyledSectionTitle = styled.div`
    margin-bottom: 16px;
    font-style: normal;
    font-weight: bold;
    color: var(--color-primary);
    text-transform: uppercase;
    font-size: var(--size-14);
    line-height: 19px;
    display: flex;
    justify-content: space-between;

    @media ${breakpoints.md} {
        font-size: var(--size-16);
        line-height: 25px;
    }

    p {
        margin: 0;
    }
`;

const SectionTitle: FC<PropsWithChildren<SectionTitleProps>> = ({ title, mobileTitle, children, ...props }) => {
    return (
        <StyledSectionTitle {...props}>
            <Hidden lgDown>
                <p>{title}</p>
            </Hidden>
            <Hidden lgUp>
                <p>{mobileTitle || title} </p>
            </Hidden>
            {children}
        </StyledSectionTitle>
    );
};

export default SectionTitle;
